export default __webpack_public_path__ + "maps-examples-camera-animators-thumbnail-960-5283b535cc23a137511ad9615959d896.webp";